export default {
  fonts: {
    primary: 'Mulish',
    secondary: 'Montserrat',
  },
};
